/** Authorization */
export const SET_PREV_PATH = 'SET_PREV_PATH';
export const CLEAR_PREV_PATH = 'CLEAR_PREV_PATH';
